import { useQuery } from "@tanstack/react-query";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

// Phase 7 sub-bucket 10 — partner-detail overview tab aggregate. Hits
// GET /api/admin/partners/:id/overview which folds the legacy
// OverviewCards' four parallel Supabase reads (attributions inbound /
// outbound, onboarding tasks, counts) into one response.
export type AdminPartnerOverviewDeal = {
  hubspotDealId: string;
  hubspotUrl: string;
  title: string;
  amount: number | null;
  currency: string;
  stageId: string | null;
  wonAt: string;
  createdAt: string;
  isWon: boolean;
  isClosed: boolean;
};

export type AdminPartnerOverviewTask = {
  id: string;
  title: string;
  status: string;
  due_date: string | null;
  assigned_to_partner: boolean;
};

export type AdminPartnerOverview = {
  revenueEur: number;
  wonCount: number;
  introCount: number;
  wonDeals: AdminPartnerOverviewDeal[];
  openTasks: AdminPartnerOverviewTask[];
  counts: {
    people: number;
    deals: number;
    // Deduped count of HubSpot attribution rows — drives the Deals tab
    // badge. Distinct from `deals` which counts the legacy `deals` table.
    dealsAttributed: number;
    openTasks: number;
  };
  hubspotPartnerUrl: string | null;
  hubspotCompanyUrl: string | null;
  hubspot_extras: Record<string, string | null>;
  hubspot_field_map: Array<{
    hubspot_property_name: string;
    display_label: string;
    display_section: string;
    hubspot_type: "string" | "enumeration" | "date" | "datetime" | "number" | "bool";
    enum_options: Array<{ label: string; value: string }> | null;
    sort_order: number;
  }>;
};

export function useAdminPartnerOverview(partnerId: string | undefined) {
  return useQuery<AdminPartnerOverview, ApiClientError>({
    queryKey: queryKeys.admin.partners.overview(partnerId ?? ""),
    queryFn: () =>
      apiFetch<AdminPartnerOverview>(`/admin/partners/${partnerId}/overview`),
    enabled: !!partnerId,
  });
}
